import { Grid, Typography, Tooltip, Box, Menu, IconButton } from '@mui/material'
import PropTypes from 'prop-types';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { enqueueSnackbar } from 'notistack';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Iconify from '../../../../reusable-components/iconify';
import { editTicketData } from '../../../../redux/slices/tickets';
import { useSelector } from '../../../../redux/store';

FacilityContacts.propTypes = {
  facilityContacts: PropTypes.array
}
export default function FacilityContacts({facilityContacts}) {

  const { id = '' } = useParams();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { ticketUsers } = useSelector((state) => state.tickets.data.ticketInfoById[id]) || {};

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  
  const handleClose = () => {
    setAnchorEl(null);
  };

  const editTicket = async ({ Id, value, updateType }) => {
    const response = await dispatch(editTicketData({ Id, value, updateType }));
    if (response) {
      enqueueSnackbar('Ticket updated successfully', { variant: 'success' });
    } else {
      enqueueSnackbar('Ticket failed to update', { variant: 'error' });
    }
    return response;
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <Iconify icon="mdi:contact-outline" width={16} height={16} color="secondary" sx={{ mr: 0.5 }} />
      <Tooltip title="Facility contacts">
        <Typography
          variant="subtitle2"
          sx={{ textDecoration: facilityContacts?.length > 0 ? 'underline' : 'none', cursor: 'pointer' }}
          display="inline"
          onClick={(event) => facilityContacts?.length > 0 ? handleClick(event) : null}
        >
          {facilityContacts.length} Facility Contacts
        </Typography>
      </Tooltip>
      {facilityContacts?.length > 0 && <Box onClick={handleClick} sx={{ cursor: 'pointer' }}>
        {open ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
      </Box>}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
        slotProps={{
          paper: {
            style: {
              boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.5)',
            },
          },
        }}
      >
        {facilityContacts?.map((contact, index) => (
          <Grid
            key={index}
            sx={{ px: 2, pb: 1 }}
            container
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
          >
            <Grid item>
              <Typography variant="subtitle2">
                {contact?.name.length > 1 && `${contact?.name} - `} {contact?.position}
                <Tooltip title="Add to ticket" placement="top" arrow>
                  <IconButton
                    onClick={() =>
                      editTicket({
                        Id: id,
                        value: [...ticketUsers.map((user) => user.userEmail), contact?.email],
                        updateType: 'Users',
                      })
                    }
                    sx={{ padding: 0 }}
                    color="secondary"
                  >
                    <Iconify icon="material-symbols:add" width={14} height={14} sx={{ ml: 1 }} />
                  </IconButton>
                </Tooltip>
              </Typography>
            </Grid>
            <Grid item>
              <Typography sx={{ fontWeight: 300 }} variant="subtitle2">
                {contact?.email}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Menu>
    </Box>
  )
}